/**
 * Whether the device says it has a network — `navigator.onLine`, read where there is a browser.
 * The server is not a device without one: it is where the page is being rendered, and Node's own
 * `navigator` has no `onLine` at all, which must not read as "offline".
 */
export const isOnline = (): boolean => typeof navigator === 'undefined' || navigator.onLine !== false;
